import {postFormData} from '../../utils/request'
import http from '../http'

export default {
  data () {
    return {
      seriesList: []
    }
  },

  methods: {
    async loadSeriesList (brandId) {
      if (!brandId) {
        this.seriesList = []
        return
      }

      const res = await postFormData(
        `distribution/B2cGoodsInfoController/queryBrand`,
        {
          brandId
        }
      ).catch(res => http.handleHttpError(res, this))

      if (res.data.code === 200) {
        this.seriesList = res.data.data.b2cGoodsSeriesList
        return
      }

      http.handleEorrorCode(res, this)
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/mixins/series.js